var _path, _path2, _mask, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.14659C2.5 6.94983 2.61539 6.77137 2.79482 6.69062L11.7948 2.64062C11.9253 2.58191 12.0747 2.58191 12.2052 2.64062L21.2052 6.69062C21.3846 6.77137 21.5 6.94983 21.5 7.14659V21C21.5 21.2761 21.2761 21.5 21 21.5H3C2.72386 21.5 2.5 21.2761 2.5 21V7.14659Z",
    stroke: "#A2A9C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.5H18.5",
    stroke: "#A2A9C8"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_630_59426",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 11L14 10.5V21.5L10 20.5V11Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11L9.50386 7.03089L6 7.46887V11H10ZM14 10.5H18V5.96887L13.5039 6.53089L14 10.5ZM14 21.5L13.0299 25.3806L18 26.6231V21.5H14ZM10 20.5H6V23.6231L9.02986 24.3806L10 20.5ZM10.4961 14.9691L14.4961 14.4691L13.5039 6.53089L9.50386 7.03089L10.4961 14.9691ZM10 10.5V21.5H18V10.5H10ZM14.9701 17.6194L10.9701 16.6194L9.02986 24.3806L13.0299 25.3806L14.9701 17.6194ZM14 20.5V11H6V20.5H14Z",
    fill: "#A2A9C8",
    mask: "url(#path-3-inside-1_630_59426)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.816e5be7a048db7802bae37eda4cae47.svg";
export { ForwardRef as ReactComponent };